export default __webpack_public_path__ + "static/media/win.16e7d466.png";